import { Bound } from "lib/@components/binding/Bound"
import { useState } from "react"
import { DifferenceWrapper } from "routes/schedule/compare/differenceWrapper"
import { Box, Stack, useTheme } from "@mui/material"
import { DifferenceTitle } from "routes/schedule/compare/difference-title"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Frequency } from "routes/schedule/tasks/frequency"
import { Status } from "routes/schedule/compare/status"
import { TargetEditor } from "routes/schedule/compare/target-editor"
import { EditModeSwitch } from "routes/schedule/compare/edit-mode-switch"
import { Approved } from "routes/schedule/compare/approved"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useBoundValue } from "lib/@components/binding/use-bound-value"

export function FrequencyChange({ label }) {
    const { target, to } = useBoundContext()
    const [interval, setInterval] = useBoundValue("frequency.interval")
    const [period, setPeriod] = useBoundValue("frequency.period")
    const [original] = useState({ interval, period })
    const [copied, setCopied] = useState(false)
    const [hover, setHover] = useState(false)
    const theme = useTheme()
    return (
        <DifferenceWrapper label={`${target.title}: ${label}`}>
            <Stack spacing={1} sx={{ width: "100%" }}>
                <DifferenceTitle label={label} />
                <ListItemBox alignItems="center">
                    <Box
                        flex={1}
                        sx={{ opacity: hover ? 0.25 : 1, transition: "opacity 0.2s linear", mr: -2 }}
                        data-cy="frequency-change-left"
                    >
                        <TargetEditor>
                            <EditModeSwitch>
                                <Bound task={target}>
                                    <Frequency />
                                </Bound>
                            </EditModeSwitch>
                        </TargetEditor>
                    </Box>
                    <Approved>
                        <Status
                            onHover={setHover}
                            onCopyChanged={setCopied}
                            copy={copy}
                            revert={revert}
                            path="frequency"
                        />
                        <Box
                            flex={1}
                            sx={{
                                opacity: copied ? 0.5 : 1,
                                borderRadius: 1,
                                transition: "background-color linear 0.2s",
                                bgcolor: hover ? `${theme.palette.primary.main}20` : undefined,
                            }}
                            data-cy="frequency-change-right"
                        >
                            <Bound target={to} task={to} editMode={false}>
                                <Frequency />
                            </Bound>
                        </Box>
                    </Approved>
                </ListItemBox>
            </Stack>
        </DifferenceWrapper>
    )

    function copy() {
        setInterval(to.frequency.interval)
        setPeriod(to.frequency.period)
    }

    function revert() {
        setInterval(original.interval)
        setPeriod(original.period)
    }
}
